import { tsValidateUniqueId } from '@nu-art/ts-common';
export const Validator_EncounterId = {
    encounterId: tsValidateUniqueId,
};
//# sourceMappingURL=validator.js.map